import React from "react";
import { withPrefix } from "gatsby-link";

import "./image.scss";

const Image = ({ data, onClick }) => {
  const { videoId, previewUrl, fullUrl } = data;
  const isVideo = videoId ? true : false;
  const displayOnClick = videoId ? videoId : fullUrl;
  return (
    <div className={`image-item`}>
      <div
        className={`image-item__btn`}
        onClick={() => onClick(isVideo, displayOnClick)}
      >
        <img src={withPrefix(previewUrl)} className={"image-item__img"} />
        <div className={"image-item__content"} />
      </div>
    </div>
  );
};

export default Image;



// WEBPACK FOOTER //
// ./src/components/Image/index.js